// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2gojI","clinicsSelect":"styles_clinicsSelect__EQ_90"};